// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"question_table_wrapper__ZYYiA","table":"question_table_table__5JBrK","tooltipHeader":"question_table_tooltipHeader__xrKmC","orderBy":"question_table_orderBy__9qMDB"};